import { GroupInfoComponent } from './GroupInfo.types';
import { Box, Typography } from '@hiiretail/synergy-ui';
import { Card } from '../../../../common/components/Card/Card';

export const GroupInfo: GroupInfoComponent = ({
  group,
}) => group ? (
  <Card styles={{
    padding: '32px',
    height: '140px',
    marginBottom: '24px',
  }}>
    <Box><Typography variant="header2">{group.name}</Typography></Box>
    <Box><Typography variant="body1">{group.description}</Typography></Box>
  </Card>
) : null;
